module.exports = __webpack_public_path__ + "static/media/pw.20a1d020.svg";